// Per-grade learning profile: content, games and UI complexity differ by grade tier.
export const BOOKS = {
  3: "Jet 1",
  4: "Jet 2 · Reading And More",
  5: "Fantastic Five + Workbook",
  6: "Think About It + Workbook",
  7: "Sky High + Workbook",
  8: "Behind the Scenes",
  9: "English Lab 9",
};

const TIERS = {
  young: {
    tier: "young",
    label: { ar: "المرحلة الأولى", en: "Early stage" },
    games: ["match", "missing", "memory", "listening", "crossword", "train"],
    quiz: { count: 3, difficulty: "easy", options: [3, 5] },
    writingModes: ["letters", "words"],
    wordsPerScreen: 6,
    scale: "text-lg",
    accent: "#ff9f1c",
  },
  middle: {
    tier: "middle",
    label: { ar: "المرحلة المتوسطة", en: "Middle stage" },
    games: ["match", "missing", "memory", "listening", "spell", "crossword", "picsearch", "train"],
    quiz: { count: 5, difficulty: "easy", options: [3, 5, 8] },
    writingModes: ["letters", "words", "sentences"],
    wordsPerScreen: 9,
    scale: "text-base",
    accent: "#2ec4b6",
  },
  senior: {
    tier: "senior",
    label: { ar: "المرحلة العليا", en: "Senior stage" },
    games: ["match", "missing", "memory", "listening", "spell", "hunt", "builder",
      "crossword", "picsearch", "train"],
    quiz: { count: 8, difficulty: "medium", options: [5, 8, 10] },
    writingModes: ["words", "sentences"],
    wordsPerScreen: 12,
    scale: "text-base",
    accent: "#3fa9ff",
  },
};

// difficulty rises with the grade AND with how far the pupil has walked the map
export const gameDiff = (grade, stage = 0) => {
  const g = Number(grade) || 3;
  const step = Math.max(0, g - 3);
  const lvl = Math.min(Math.floor(Number(stage || 0) / 4), 4); // +1 level every 4 map stops
  return {
    grade: g,
    stage: Number(stage || 0),
    level: lvl,
    words: Math.min(4 + step + lvl, 10),
    letterOptions: Math.min(4 + Math.floor((step + lvl) / 2), 6),
    memoryPairs: Math.min(3 + Math.ceil(step / 1.5) + lvl, 9),
    spellWords: Math.min(3 + Math.ceil(step / 1.5) + lvl, 9),
    meaningOptions: Math.min((g <= 4 ? 3 : g <= 6 ? 4 : 5) + (lvl >= 3 ? 1 : 0), 6),
    huntSize: Math.min((g <= 6 ? 7 : g <= 8 ? 9 : 10) + lvl, 12),
    minWordLen: g <= 4 ? 3 : g <= 6 ? 4 : 5,
    builderRounds: Math.min((g <= 4 ? 2 : g <= 7 ? 3 : 4) + (lvl >= 2 ? 1 : 0), 6),
    builderWords: g <= 4 ? 5 : g <= 6 ? 8 : g <= 8 ? 11 : 13,
    hideLetters: Math.min((g <= 5 ? 1 : g <= 7 ? 2 : 3) + (lvl >= 3 ? 1 : 0), 4),
  };
};

export const gradeProfile = (grade) => {
  const g = Number(grade) || 3;
  const base = g <= 4 ? TIERS.young : g <= 6 ? TIERS.middle : TIERS.senior;
  return { ...base, grade: g, book: BOOKS[g] || "English Lab" };
};
